var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2180 4605 l0 -115 1075 0 1075 0 0 -1935 0 -1935 -1075 0 -1075 0 0 -115 0 -115 1185 0 1185 0 0 2165 0 2165 -1185 0 -1185 0 0 -115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2365 3740 l-80 -80 490 -490 490 -490 -1413 0 -1412 0 0 -115 0 -115 1407 0 1408 0 -485 -485 -485 -485 83 -82 82 -83 628 628 627 627 -625 625 c-344 344 -627 625 -630 625 -3 0 -41 -36 -85 -80z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.d885965fd925715e96bf2c582728545f.svg";
export { ForwardRef as ReactComponent };